import Header from "../components/Header";
import {Delete, Download, Edit2, Edit3, Plus, Trash, Trash2} from "react-feather";
import {NavLink, useParams} from "react-router-dom";
import InputWrapper from "../../components/InputWrapper";
import Form from "../components/Form";
import {useEffect, useState} from "react";
import Data from "../../Data";
import {useForm} from "react-hook-form";
import ExperienceImageUpload from "../components/ExperienceImageUpload";
import Meta from "../../../components/Meta";
import {combineDurationParts, splitDurationMinutes} from "../../utils/duration";

const Edit = () => {
    const { id } = useParams();

    const [experience, setExperience] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false)
    const [duration, setDuration] = useState({ days: 0, hours: 0, minutes: 0 });
    const [durationError, setDurationError] = useState(null);

    useEffect(async () => {
        try {
            const experience = await Data.fetchExperienceById({ id })
            setExperience(experience.data)
            reset(experience.data)
            setDuration(splitDurationMinutes(experience.data.duration))
        } catch(error){
            window.location.href = '/admin/experiences'
        } finally {
            setLoading(false)
        }
    }, []);

    const { register, handleSubmit, formState: { errors }, reset } = useForm()

    const submit = async (data) => {
        setLoading(true)
        const totalDuration = combineDurationParts(duration);

        if (totalDuration <= 0) {
            setLoading(false);
            setDurationError("Duration must be at least 1 minute");
            return;
        }

        try {
            setDurationError(null);
            const result = await Data.updateExperience({ id, experience: { ...data, duration: totalDuration } })
            window.location.href = '/admin/experiences/' + result.data._id;

            setLoading(false)
            setError(false)
        } catch(error) {
            setLoading(false)
            setError(true)
        }
    }

    return (
        <>
            <Meta title={`Edit ${experience.name}`} />
            <Header heading={"Edit Details"} backToLabel={experience.name} backToTo={`/admin/experiences/${id}`} />
            <div className={"p-3 lg:p-6 grid grid-cols-1 gap-3 lg:gap-6 w-full overflow-x-scroll"}>

                <Form heading={"Listing Details"} onSubmit={handleSubmit(submit)}>

                    <InputWrapper label={"Name"} input={<input type={"text"} {...register('name', {required: true})} />}
                                  error={errors.name ? "This field is required" : null}/>
                    <InputWrapper label={"Published"} input={<select {...register('isPublished',)}>
                        <option value={"true"}>Published</option>
                        <option value={"false"}>Unpublished</option>
                    </select>}/>
                    <InputWrapper label={"Short Description"}
                                  input={<input type={"text"} {...register('shortDescription')} />}/>
                    <InputWrapper label={"Description"} input={<textarea {...register('description',)} />}/>
                    <InputWrapper label={"Additional Details"}
                                  input={<textarea {...register('additionalDetails',)} />}/>
                    <InputWrapper label={"Cancellation Policy"}
                                  input={<textarea {...register('cancellationPolicy',)} />}/>
                    <InputWrapper label={"Location"} input={<input type={"text"} {...register('location')} />}/>
                    <InputWrapper label={"RemoteLock Lock ID"}
                                  input={<input type={"text"} {...register('lockstateLockId')} />}
                                  error={null}/>
                    <InputWrapper label={"Secondary RemoteLock Lock ID"}
                                  input={<input type={"text"} {...register('secondaryLockstateLockId')} />}
                                  error={null}/>
                    <InputWrapper label={"Duration"}
                                  input={
                                      <div className={"grid grid-cols-1 sm:grid-cols-3 gap-2"}>
                                          <label className={"grid gap-1"}>
                                              <span className={"text-xs text-textGrey"}>Days</span>
                                              <input
                                                  type={"number"}
                                                  min={"0"}
                                                  value={duration.days}
                                                  onChange={(event) => setDuration(current => ({ ...current, days: event.target.value }))}
                                              />
                                          </label>
                                          <label className={"grid gap-1"}>
                                              <span className={"text-xs text-textGrey"}>Hours</span>
                                              <input
                                                  type={"number"}
                                                  min={"0"}
                                                  value={duration.hours}
                                                  onChange={(event) => setDuration(current => ({ ...current, hours: event.target.value }))}
                                              />
                                          </label>
                                          <label className={"grid gap-1"}>
                                              <span className={"text-xs text-textGrey"}>Minutes</span>
                                              <input
                                                  type={"number"}
                                                  min={"0"}
                                                  value={duration.minutes}
                                                  onChange={(event) => setDuration(current => ({ ...current, minutes: event.target.value }))}
                                              />
                                          </label>
                                      </div>
                                  }
                                  error={durationError}/>
                    <InputWrapper label={"Price"}
                                  input={<input type={"number"} {...register('price', {required: true})} />}/>
                    <InputWrapper label={"Pricing Label"} input={<select {...register('pricingLabel')}>
                        <option value={"per person"}>Per Person</option>
                        <option value={"per session"}>Per Session</option>
                        <option value={"per booking"}>Per Booking</option>
                    </select>}/>
                    <InputWrapper label={"Refund Window (Hours)"}
                                  input={<input type={"number"} {...register('refundWindow', {required: true})} />}
                                  error={errors.refundWindow ? "This field is required" : null}/>
                    <InputWrapper label={"Deposit Amount (£, 0 = disabled)"}
                                  input={<input type={"number"} step={"0.01"} min={"0"} {...register('depositAmount')} />}/>
                    <InputWrapper label={"Minimum People"}
                                  input={<input type={"number"} {...register('minPeople', {required: true})} />}
                                  error={errors.minPeople ? "This field is required" : null}/>
                    <InputWrapper label={"Maximum People"}
                                  input={<input type={"number"} {...register('maxPeople', {required: true})} />}
                                  error={errors.maxPeople ? "This field is required" : null}/>
                    <InputWrapper label={"Sort Order"}
                                  input={<input type={"number"} {...register('sortOrder')} />}/>

                    <div className={"mt-2 flex gap-2"}>
                        <button type={"submit"} disabled={loading}
                                className={"bg-backgroundGrey border px-2.5 py-1.5 rounded-md hover:opacity-80 transition"}>{loading ? "Saving..." : "Save Changes"}</button>
                    </div>
                </Form>

                <ExperienceImageUpload/>
            </div>
        </>
    )
}

export default Edit
